import { LocaleModule } from "@/core/modules/locale/objects/LocaleModule";

import { en } from "./en";
import { it } from "./it";

export const testFormLocaleModule: LocaleModule = {
  name: "testForm",
  messages: { en: en, it: it },
};
